/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TAddLegalAgreementRequest,
  TAddLegalAgreementModel,
  IMappers,
  TAddLegalAgreementResponse,
  TAddLegalAgreementResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createAddLegalAgreementModel(parameters: TAddLegalAgreementRequest): TAddLegalAgreementModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'users-features',
    pathApi: '/v1/add-legal-agreement/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAddLegalAgreementOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAddLegalAgreementRequest;
}

export async function fetchAddLegalAgreement<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddLegalAgreementOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TAddLegalAgreementResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddLegalAgreementModel(parameters),
    config,
  )) as FetchResponse<TAddLegalAgreementResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TAddLegalAgreementResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAddLegalAgreementResponse>;
}
